import React, { useEffect } from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import PageIntro from "../../components/PageIntro";
import PropertyGrid from "../../components/PropertyGrid";
import { useSelector } from "react-redux";
import selectedOptions from "../../app/reducers/selectedOptions";
import { useNavigate } from "react-router-dom";
const Index = ({ title, description }) => {
  const navigate = useNavigate();
  const searchedState = useSelector((state) => state.searchedProperties);

  const { status, error, searchedProperties } = searchedState;

  const searchedterms = useSelector((state) => state.selectedOptions);
  console.log("searchedProperties", searchedProperties);
  useEffect(() => {
    if (status === "idle") {
      navigate("/");
    }
  }, []);
  return (
    <Pageslayout
      //   pageintro={true}
      title="Searched results"
      description="Properties related to your search"
      active="true"
    >
      <div className="w-full py-4  px-2 md:px-8 lg:px-8 bg-[#f5f5f5] flex justify-center items-center gap-2 ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 50 50"
        >
          <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"></path>
        </svg>
        <p className="font-semibold text-xl text-center">Searched results</p>
      </div>

      {status === "loading" ? (
        <div className="flex justify-center items-center py-20">
          <img
            src="
        /assets/loader/loader.png"
            alt=""
          />
        </div>
      ) : (
        <>
          {status === "failed" ? (
            <div className="text-red-500 text-xl text-center py-20">
              An error occured, Error Message : {error}
            </div>
          ) : (
            <>
              <div className="w-full py-4  px-2 md:px-8 lg:px-8   gap-2 flex justify-center items-center flex-wrap ">
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  <span className="font-bold">City : </span>{" "}
                  {searchedterms.city}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  <span className="font-bold">Keywords: </span>
                  {searchedterms.keywords}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  <span className="font-bold">Property Type : </span>
                  {searchedterms.propertyType}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  <span className="font-bold">Area : </span>{" "}
                  {searchedterms.area}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  <span className="font-bold">Price : </span>
                  {searchedterms.price}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  {" "}
                  <span className="font-bold">Features: </span>
                  {searchedterms.features}
                </p>
                <p className="bg-[#e6e5e5] shadow-sm p-[6px] text-sm rounded-md ">
                  {" "}
                  <span className="font-bold">Category : </span>
                  {searchedterms.subType}
                </p>
              </div>

              <div className="w-full  ">
                <div className="flex gap-4  flex-wrap lg:flex-nowrap w-full py-4  px-2 md:px-8 lg:px-8">
                  <PropertyGrid properties={searchedProperties} />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </Pageslayout>
  );
};
export default Index;
